import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface SafetyInterventionsSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Remove triggers and reduce stimulation",
  "Maintain safe distance and ensure supervision is available",
  'Offer short, non-threatening prompts (e.g., "You are safe. I\'m here to help.")',
  "Evacuate other students to a place of safety",
  "Offer known calming strategies if safe, e.g. sensory spaces",
  "Avoid attempting to reason or enforce consequences to reduce demands",
  "Secure potentially dangerous items",
  "Contact the office to seek assistance from executive staff",
  "Monitor for signs of de-escalation in body language, tone or pacing",
  "Avoid any physical intervention unless trained and required",
  "Use the person's name and short, simple sentences",
  'Explain that desired behaviour will lead to desired outcome, e.g. "When you sit down, I can help you."',
];

export const SafetyInterventionsSection: React.FC<
  SafetyInterventionsSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Describe appropriate safety interventions at this stage:"
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="safetyInterventionsOther">
        Other:
      </label>
      <input
        type="text"
        id="safetyInterventionsOther"
        name="safetyInterventionsOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
